import { render } from "./RankView.vue?vue&type=template&id=18a5f6cb"
import script from "./RankView.vue?vue&type=script&lang=js"
export * from "./RankView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__